const cols = [
  {
    title: "站内导航",
    links: [
      { label: "今日热度榜", href: "#board" },
      { label: "今日瓜点速报", href: "#feed" },
      { label: "重点事件时间线", href: "#timeline" },
      { label: "正在发酵话题墙", href: "#topics" },
    ],
  },
  {
    title: "深读与复盘",
    links: [
      { label: "背景解析专栏", href: "#analysis" },
      { label: "完整复盘档案", href: "#replay" },
      { label: "快速入口", href: "#top" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="wrap py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-3">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-google-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="brand-face text-2xl tracking-wide text-foreground-950">
                21<span className="text-primary-500">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              事件梳理与时间线完整呈现，前因后果背景解析一次讲透，完整复盘帮你理清脉络，吃瓜不迷路。
            </p>
            <div className="mt-5 flex gap-2">
              <span className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </span>
              <span className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-bilibili-line" aria-hidden="true"></i>
              </span>
              <span className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </span>
              <span className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600">
                <i className="ri-tiktok-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="grid grid-cols-2 gap-6 sm:grid-cols-2">
              {cols.map((c) => (
                <div key={c.title}>
                  <h4 className="font-heading text-sm font-bold text-foreground-950">{c.title}</h4>
                  <ul className="mt-4 flex flex-col gap-2.5">
                    {c.links.map((l) => (
                      <li key={l.label}>
                        <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                          {l.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200/70">
        <div className="wrap flex flex-col items-center justify-between gap-2 py-4 sm:flex-row">
          <p className="text-xs text-foreground-500">
            本站内容基于公开信息进行事件梳理与背景解析，仅作信息展示用途，不构成任何立场判断。
          </p>
          <p className="whitespace-nowrap text-xs text-foreground-500">© 2026 21吃瓜 · 事件梳理与完整复盘</p>
        </div>
      </div>
    </footer>
  );
}